import React from 'react';
import { Row, Card, CardBody, Container, Col } from 'reactstrap';
import ThemeOptions from '../../Layout/ThemeOptions';
import AppHeader from '../../Layout/AppHeader';
import AppSidebar from '../../Layout/AppSidebar';
import Storage from '../../services/Storage';

const Contact = () => {
  const token = Storage.getTokenDetail() || {};
  const handlePolicy = () => {
    window.open('https://dms.agrocel.net/policy/PrivacyPolicy.html', '_blank');
  };
  return (
    <>
      {token.accessToken ? <AppHeader /> : ''}
      <div className='app-main' style={{ paddingTop: `${token.accessToken ? '60px' : '10px'}` }}>
      {token.accessToken ? <AppSidebar /> : ''}
        <div className='app-main__outer' style={{ paddingLeft: `${token.accessToken ? '60px' : '10px'}` }}>
          <div className='app-main__inner rms-wrapper'>
            <div id='ClientUser'>
              <Container fluid>
                <Row>
                  <Col xs={12}>
                    <span className='header-title'>Contact Us</span>
                    <br />
                    <br />
                    <div style={{ marginTop: '100px' }}>
                      <Card style={{ width: 'auto', maxWidth: '400px', margin: 'auto' }}>
                        <CardBody>
                          <Row
                            style={{
                              marginLeft: 'auto',
                              marginRight: 'auto',
                              marginBottom: '1%',
                              justifyContent: 'space-between',
                            }}
                          >
                            <p className='header-title'>Head Office</p>

                            <br />
                            <br />

                            {/* <p class='Download-Full-Report' style={{ width: '100%' }}>
                      H-609 Titanium City Center,100 Feet Rd,
                      <br />
                      Satellite, Ahmedabad - 380015
                      <br />
                      Gujarat(India)
                    </p> */}

                            <p className='Download-Full-Report' style={{ width: '100%' }}>
                              Lomoso Solutions Private Limited
                              <br />
                              716, Binori Bsquare 3
                              <br />
                              Sindhubhavan Marg
                              <br />
                              Bodakdev, Ahmedabad
                              <br />
                              Gujarat 380054
                            </p>

                            <br />
                            <br />

                            <label
                              className='capitalize'
                              style={{
                                fontSize: '12px',
                                color: '#545cd8',
                              }}
                            >
                              +91 9081111261
                            </label>

                            <label
                              className='capitalize'
                              style={{
                                fontSize: '12px',
                                color: '#545cd8',
                              }}
                            >
                              support@trackwalkins.com
                            </label>
                            <div>For Privacy Policy of program please refer <span onClick={handlePolicy} style={{ cursor: 'pointer', color: 'rgb(84, 92, 216)' }}>here</span></div>
                          </Row>
                        </CardBody>
                      </Card>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
